export default "__VITE_ASSET__HU39jeuC__"